module.exports = __webpack_public_path__ + "media/images/bg/mosaic/performance-79d96b86c8a05569f469e9b05421e0a0.jpg";